export const EventBus = document.body;

export const EventTypes = Object.freeze({
  ALL_COMPONENTS_READY: 'ALL_COMPONENTS_READY',
  CHART_DATASETS_UPDATE: 'CHART_DATASETS_UPDATE',
  CHART_GLOBALFILTER_UPDATE: 'CHART_GLOBALFILTER_UPDATE',
  CHART_GLOBALFILTER_REQUEST: 'CHART_GLOBALFILTER_REQUEST',
  SALARY_LEGEND_UPDATE: 'SALARY_LEGEND_UPDATE',
  CHART_LEGEND_UPDATE: 'CHART_LEGEND_UPDATE',
  CHART_LEGEND_RENDERING_DONE: 'CHART_LEGEND_RENDERING_DONE',
})
